import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../../../shared/services/base-http.service';
import { CONTROLLER_CONSTANTS } from '../../../shared/constants/controller.constants';
import { ENDPOINT_CONSTANTS } from '../../../shared/constants/endpoint.constants';
import {
  AcceptedOrganogramRole,
  OrganogramRoleAssignment,
  TenantMember
} from '../interfaces/tenant-members.interface';

interface ApiResponse<T> {
  isSuccess?: boolean;
  message?: string;
  data?: T;
}

@Injectable({ providedIn: 'root' })
export class TenantMembersService {
  constructor(private baseHttp: BaseHttpService) {}

  listMembers(): Observable<ApiResponse<TenantMember[]>> {
    const endpoint = `/${CONTROLLER_CONSTANTS.TENANT_MEMBERS}/${ENDPOINT_CONSTANTS.MEMBERS}`;
    return this.baseHttp.get<ApiResponse<TenantMember[]>>(endpoint);
  }

  listAcceptedRoles(): Observable<ApiResponse<AcceptedOrganogramRole[]>> {
    const endpoint = `/${CONTROLLER_CONSTANTS.TENANT_MEMBERS}/${ENDPOINT_CONSTANTS.ACCEPTED_ORGANOGRAM_ROLES}`;
    return this.baseHttp.get<ApiResponse<AcceptedOrganogramRole[]>>(endpoint);
  }

  assignOrganogramRole(
    userId: string,
    organogramRoleId: string | null
  ): Observable<ApiResponse<OrganogramRoleAssignment>> {
    const endpoint = `/${CONTROLLER_CONSTANTS.TENANT_MEMBERS}/${ENDPOINT_CONSTANTS.MEMBERS}/${userId}/OrganogramRole`;
    return this.baseHttp.put<ApiResponse<OrganogramRoleAssignment>>(endpoint, {
      organogramRoleId
    });
  }

  getMyOrganogramRole(): Observable<ApiResponse<OrganogramRoleAssignment>> {
    const endpoint = `/${CONTROLLER_CONSTANTS.TENANT_MEMBERS}/${ENDPOINT_CONSTANTS.ME_ORGANOGRAM_ROLE}`;
    return this.baseHttp.get<ApiResponse<OrganogramRoleAssignment>>(endpoint);
  }
}
